module.exports = __webpack_public_path__ + "static/KIN1-aa4fcca039ce80f5d61a4afac0588f22.jpg";